import React from "react";
import PropTypes from "prop-types";
import { Modal, Table, Avatar } from "../../../components/ui";
import moment from "moment";
import ApiConfig from "../../../api/ApiConfig";

const ViewMembersModal = ({ show, onHide, members }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      title={<span className="comm-teams__modal-title">Members</span>}
      size="lg"
    >
      <Table compact>
        <thead>
          <tr>
            <th></th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Last Seen</th>
          </tr>
        </thead>
        <tbody>
          {members.map((member, index) => {
            const isOnline = member.user_status !== null;
            return (
              <tr key={"member" + index}>
                <td>
                  <span
                    className={
                      isOnline
                        ? "comm-teams__members-status"
                        : "comm-teams__members-status comm-teams__members-status--offline"
                    }
                    aria-label={isOnline ? "Online" : "Offline"}
                  />
                </td>
                <td>
                  <div className="comm-teams__members-table-cell">
                    <Avatar
                      src={
                        member.PhotoPath
                          ? ApiConfig.BASE_URL_FOR_IMAGES + member.PhotoPath
                          : ""
                      }
                      name={`${member.FirstName} ${member.LastName}`}
                      size="sm"
                    />
                    <span>{member.FirstName}</span>
                  </div>
                </td>
                <td>{member.LastName}</td>
                <td>
                  {member.last_seen !== null
                    ? moment(member.last_seen).fromNow()
                    : ""}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Modal>
  );
};

ViewMembersModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  members: PropTypes.array.isRequired,
};

export default ViewMembersModal;
